export default "__VITE_ASSET__KNSCq18IxAbYGwmHFzrGnA__"